import { render, staticRenderFns } from "./FieldCustomerTermsAccept.vue?vue&type=template&id=71d81fe9&scoped=true&"
import script from "./FieldCustomerTermsAccept.vue?vue&type=script&lang=js&"
export * from "./FieldCustomerTermsAccept.vue?vue&type=script&lang=js&"
import style0 from "./FieldCustomerTermsAccept.vue?vue&type=style&index=0&id=71d81fe9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d81fe9",
  null
  
)

export default component.exports